import React from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  width: 100%;
  background: #7a3e00;
  color: #fff7e6;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  z-index: 1050;
`;

const BannerLink = styled.a`
  color: #ffe08a;
  margin-left: 8px;
  text-decoration: underline;

  &:hover {
    color: #fff;
  }
`;

export default function DevUnlockBanner(): JSX.Element {
  return (
    <Banner role="status">
      DEV unlock ativo — rotas liberadas apenas neste navegador (env + cookie DEV_MODE).
      <BannerLink href="/dev/rotas">Abrir catálogo de rotas</BannerLink>
    </Banner>
  );
}
